import * as React from "react";
import { createRoot } from "react-dom/client";
import { FC } from "react";
import { Control } from "ol/control";
import { Point } from "ol/geom";
import homeSvg from "../img/icons/home-icon.svg";

export const Home: FC<{ this: Control; title: string }> = (props) => {
  const onClick = () => {
    const view = props.this.getMap().getView();
    view.fit(new Point([2695217.034668637, 7728877.262046031]), {
      maxZoom: 7.0670086534273295,
      padding: [0, 0, 0, view.get("paddingLeft")],
      duration: 1000,
    });
  };

  return (
    <>
      <div className="home-button" onClick={onClick} title={props.title}>
        <img src={homeSvg} />
      </div>
    </>
  );
};

export class HomeButton extends Control {
  constructor(title: string) {
    const element = document.createElement("div");
    element.className =
      "dabaskartes-map-button home-container ol-unselectable ol-control";
    element.id = "home-button";
    super({
      element,
    });
    const root = createRoot(element);
    root.render(<Home this={this} title={title} />);
  }
}
